import { useState } from 'react';
import { faqs } from '../../data/mockData';
import SectionHeading from '../ui/SectionHeading';
import beforeApplyImage from '../../assets/before-apply-image.jpg';

export default function Faqs() {
  const [openId, setOpenId] = useState<string | null>(faqs[0]?.id ?? null);

  return (
    <section className="relative overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0 -z-10">
        <img
          src={beforeApplyImage}
          alt="Before you apply background"
          className="h-full w-full object-cover"
          loading="lazy"
        />
        {/* Overlay for content contrast */}
        <div className="absolute inset-0 bg-gradient-to-b from-white/90 to-white/85" />
      </div>

      <div className="section-shell relative z-10">
        <SectionHeading
          eyebrow="Common questions"
          title="Before you apply"
          description="The questions we get asked most often about our programmes and accreditation."
        />

        <div className="mx-auto mt-12 max-w-3xl space-y-3">
          {faqs.map((faq) => {
            const isOpen = openId === faq.id;
            return (
              <div key={faq.id} className="card-surface overflow-hidden">
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? null : faq.id)}
                    aria-expanded={isOpen}
                    className="flex w-full items-center justify-between gap-4 p-5 text-left"
                  >
                    <span className="text-base font-bold text-brand-950">
                      {faq.question}
                    </span>
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-all duration-200 ${
                        isOpen
                          ? 'rotate-180 bg-brand-700 text-white'
                          : 'bg-brand-50 text-brand-700'
                      }`}
                    >
                      <svg
                        className="h-4 w-4"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        aria-hidden="true"
                      >
                        <path d="m6 9 6 6 6-6" />
                      </svg>
                    </span>
                  </button>
                </h3>
                {isOpen && (
                  <p className="px-5 pb-5 text-sm leading-relaxed text-brand-900/65">
                    {faq.answer}
                  </p>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
